/**
 * Limpieza y desregistro de Service Workers.
 * Elimina cualquier Service Worker previo y limpia las cachés asociadas
 * para evitar interferencias o problemas de caché en los navegadores de los usuarios.
 */

export function unregister() {
  if ('serviceWorker' in navigator) {
    // Desregistrar todos los workers activos o registrados
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
      })
      .catch((error) => {
        console.error('[SW] Error al desregistrar Service Worker:', error);
      });

    // Limpiar cachés creadas previamente por el service worker
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        return Promise.all(
          cacheNames
            .filter((name) => name.startsWith('ite-'))
            .map((name) => caches.delete(name))
        );
      }).catch((error) => {
        console.error('[SW] Error al limpiar cachés:', error);
      });
    }
  }
}

